import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketFavoriteControl',
  props: {
  isFavorite: { type: Boolean } /** Whether favorite or non-favorite state is displayed */,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createBlock(_component_x_button, {
    class: _normalizeClass([['market-favorite-control', { 'market-favorite-control--active': __props.isFavorite }], "market-favorite-control"]),
    size: "3xs",
    variant: "clear",
    block: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ot_icon, {
        class: "market-favorite-control__icon",
        name: __props.isFavorite ? 'bookmark-bold' : 'bookmark'
      }, null, 8, ["name"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})